import Row from './Row/index.vue';
import Column from './Column/index.vue';
import Scroll from './Scroll/index.vue';
import Grid from './Grid/index.vue';
import GridItem from './Grid/item.vue';
import WgGameIcon from './GameIcon/index.vue';
import WgText from './Text/index.vue';
import WgImage from './Image/index.vue';
import NormalButton from '../NormalButton/index.vue';
import Icon from '../Icon/index.vue'; 

export default {
    'row': Row,
    'column': Column,
    'scroll': Scroll,
    'grid': Grid,
    'grid-item': GridItem,
    'wg-game-icon': WgGameIcon,
    'wg-icon': Icon,
    'wg-text': WgText,
    'wg-image': WgImage,
    'wg-button': NormalButton,
}